export default __webpack_public_path__ + "static/media/krrishirKotha.e663f622.png";